import {
  SurveySettings,
} from '../../types';
import { apiError } from '../../utils/errors';

export interface AdditionalTradeReferencesData {
  settings: SurveySettings;
}

export const getAdditionalTradeReferencesData = async (
  urlSlug: string,
  publicId: string,
  token?: string,
): Promise<AdditionalTradeReferencesData> => {
  const baseUrl = `${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/additional-trade-references`;
  const url = token ? `${baseUrl}?token=${token}` : baseUrl;
  const response = await fetch(url, { credentials: 'include' });
  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch additional trade references data', responseJson?.code);
  }

  return responseJson.data;
};
